import { combineReducers } from "redux";
// Front
import Layout from "./layout/reducer";
// Calendar
import calendar from "./calendar/reducer";
// Authentication
import forgetPassword from "./auth/forgetpwd/reducer";
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";
//Main-Modules
import users from "./users/reducer"
import userdetails from "../store/userdetails/reducer";
import zones from "../store/zones/reducer"
import organisation from '../store/organisation/reducer'
import device from '../store/device/reducer'
import products from "../store/products/reducer"
import deviceDetails from "../store/deviceDetails/reducer";
import requests from "../store/requests/reducer"
import approvals from "../store/approvals/reducer"
import organisationDetails from "../store/organisationDetails/reducer"
import form from "../store/form/reducer"
import snackbar from "../store/snackbar/reducer"
import dashboard from "../store/dashboard/reducer"
import returnApprovals from "../store/returnApprovals/reducer"
import returnRequests from "../store/returnRequests/reducer";
import returnReason from "../store/settings/returnReason/reducer";
import appVersion from "../store/appVersion/reducers";
import SettingsInlineEdit from "../store/settings/SettingsInlineUpdate/reducers";

const rootReducer = combineReducers({
  // public
  Layout,
  calendar,
  forgetPassword,
  login,
  profile,
  account,
  snackbar,
  users,
  userdetails,
  zones,
  organisation,
  device,
  products,
  deviceDetails,
  requests,
  approvals,
  organisationDetails,
  form: form,
  dashboard,
  returnApprovals,
  returnRequests,
  appVersion,
  returnReason,
  SettingsInlineEdit
});

export default rootReducer;
